import { useLocale } from '@va/localization';
import { CommonProps } from '@va/types/component';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import { ChoroplethMap, ChoroplethMapCfg } from './choropleth-map';

type ChoroplethMapComponentProps<T> = Omit<ChoroplethMapCfg<T>, 'containerEl'> & CommonProps;

export const ChoroplethMapComponent = <T extends {}>(props: ChoroplethMapComponentProps<T>) => {
  const { locale } = useLocale();
  const wrapperRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<ChoroplethMap<T> | null>(null);

  useEffect(() => {
    if (mapRef.current) return;
    if (!wrapperRef.current) return;

    mapRef.current = new ChoroplethMap({ ...props, containerEl: wrapperRef.current });
  }, [props]);

  useEffect(() => {
    if (!mapRef.current) return;

    mapRef.current.update({ ...props });

    // eslint-disable-next-line
  }, [props.data, props.markersEnabled, locale]);

  return (
    <div
      data-testid={props['data-testid']}
      ref={wrapperRef}
      className={classNames('overflow-hidden', props.className)}
      style={props.style}
    ></div>
  );
};
